import React from 'react'
import { Redirect, useRoutes, navigate, useLocationChange } from 'raviger'
import {
  PublicTemplate,
  PrivateTemplate,
  HomePage,
  LoginPage,
  ProgramDetailsPage,
  ProgramsPage,
  DataCenterTemplate,
  DataCenterHomePage,
  ProgramListPage,
  ProgramUpdatesPage,
  SearchPage,
  AdvancedSearchPage,
  MemberDetailPage,
  ReportsPage,
  NotFoundPage,
  DataCenterActions,
  HelpInfo,
  GetDataPage,
  GetDataInformation,
  MemberMapPage,
  LandscapeReportsPage,
} from 'components'
import { checkPermission } from 'utils/permission'

const ProtectedRoute = ({ children, permissions }) => {
  return checkPermission(permissions) ? children : <Redirect to="/" />
}

function scrollToTop() {
  window.scrollTo({ top: 0 })
}

const routes = {
  '/login': () => <PublicTemplate component={LoginPage} />,
  '/': () => <PrivateTemplate component={HomePage} />,
  '/programs': () => (
    <PrivateTemplate component={ProgramsPage} bread={['home', 'my_programs']} />
  ),
  '/programs/:id': ({ id }) => (
    <PrivateTemplate
      component={ProgramDetailsPage}
      id={id}
      bread={['home', 'my_programs', 'program_detail']}
    />
  ),
  '/programs-search/:id': ({ id }) => (
    <PrivateTemplate
      component={ProgramDetailsPage}
      id={id}
      bread={['home', 'member_search', 'program_detail']}
    />
  ),
  '/data-center': () => (
    <ProtectedRoute permissions={['canManageMemberScholarships']}>
      <DataCenterTemplate
        component={DataCenterHomePage}
        title="Data Center Home"
        about="data_center_home_about"
        subsection={DataCenterActions}
      />
    </ProtectedRoute>
  ),
  '/data-center/programs': () => (
    <ProtectedRoute permissions={['canManageMemberScholarships']}>
      <DataCenterTemplate
        component={ProgramListPage}
        title="Your Programs"
        about="data_center_programs_about"
      />
    </ProtectedRoute>
  ),
  '/data-center/program-updates': () => (
    <ProtectedRoute permissions={['canManageMemberScholarships']}>
      <DataCenterTemplate
        component={ProgramUpdatesPage}
        title="Your Program Updates"
        about="data_center_your_program_updates_about"
      />
    </ProtectedRoute>
  ),
  '/data-center/help-info': () => (
    <DataCenterTemplate
      component={HelpInfo}
      title="Help & Info"
      about="data_center_help_info"
    />
  ),
  '/data-center/get-data': () => (
    <DataCenterTemplate
      component={GetDataPage}
      title="Get Data"
      about="data_center_get_data_about"
      subsection={GetDataInformation}
    />
  ),
  '/comparison/:report': ({ report }) => (
    <PrivateTemplate
      component={ReportsPage}
      report={report}
      bread={['home', report]}
    />
  ),
  '/reportcenter/landscape': () => (
    <PrivateTemplate
      component={LandscapeReportsPage}
      bread={['home', 'landscape_reports']}
    />
  ),
  '/search': () => <PrivateTemplate component={SearchPage} />,
  '/search/advanced': () => (
    <PrivateTemplate
      component={AdvancedSearchPage}
      bread={['home', 'member_search']}
    />
  ),
  '/search/advanced/:search': ({ search }) => (
    <PrivateTemplate
      component={AdvancedSearchPage}
      search={search}
      bread={['home', `member_search_${search}`]}
    />
  ),
  '/member-detail': () => (
    <PrivateTemplate
      component={MemberDetailPage}
      bread={['home', 'organization']}
    />
  ),
  '/member-detail-search': () => (
    <PrivateTemplate
      component={MemberDetailPage}
      bread={['home', 'member_search', 'member_detail']}
    />
  ),
  '/organization-detail-search': () => (
    <PrivateTemplate
      component={MemberDetailPage}
      bread={['home', 'member_org_search', 'member_detail']}
    />
  ),
  '/reports': () => <PrivateTemplate component={ReportsPage} />,
  '/notfound': () => <PrivateTemplate component={NotFoundPage} />,
  '/member-map': () => (
    <PrivateTemplate component={MemberMapPage} bread={['home', 'map']} />
  ),
}

export default () => {
  const routeResult = useRoutes(routes)
  if (!routeResult) {
    setTimeout(() => navigate('/', true)) // Not found
  }
  useLocationChange(scrollToTop)
  return routeResult
}
